import React, {Component} from 'react';
import {BarChart, Bar, XAxis, YAxis, CartesianGrid, ResponsiveContainer, Tooltip} from 'recharts';
import * as formatter from "../utils/formatters";

class OperationalPortfolioStatusGraph extends Component{

  constructor(props){
    super(props);
    this.state={data:this.props.data}
  }

  render() {
    return (
      <ResponsiveContainer>
        <BarChart width={600} height={300} data={this.state.data}>
          <XAxis dataKey={"type"} tick={false} type={"category"} name={"Tipo"}/>
          <YAxis tickFormatter={formatter.formatNumber} scale={'linear'}/>
          <Tooltip formatter={formatter.formatNumber}/>
          <CartesianGrid/>
          <Bar type={"monotone"} dataKey={"quantity"} name={"Cantidad"}barSize={30} fill="#222"/>
        </BarChart>
      </ResponsiveContainer>
    );
  }
}

export default OperationalPortfolioStatusGraph;



// WEBPACK FOOTER //
// ./src/charts/operationalPortfolioStatusGraph.js